// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Variables */
* {
    box-sizing: border-box;
}

/* body {
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  display: flex;
  justify-content: center;
  align-content: center;
  height: 100vh;
  width: 100vw;
} */

form {
    width: 30vw;
    min-width: 500px;
    align-self: center;
    box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),
    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
    border-radius: 5px;
    padding: 40px;
}

.cursor {
    cursor: pointer;
}

.promoCodeInput {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 50%;
}

.hidden {
    display: none;
}

#payment-message {
    color: rgb(149, 40, 0);
    font-size: 16px;
    line-height: 20px;
    padding-top: 12px;
    text-align: center;
}

#payment-element {
    margin-bottom: 24px;
}

/* Buttons and links */

/*button {
  background: #6e5eff;
  font-family: Roboto, "Helvetica Neue", sans-serif;
  color: #ffffff;
  border-radius: 5px;
  border: 0;
  padding: 12px 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: block;
  transition: all 0.2s ease;
  box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);
  width: 100%;
}
button:hover {
  filter: contrast(115%);
}
button:disabled {
  opacity: 0.5;
  cursor: default;
}*/

/* spinner/processing state, errors */
.spinner,
.spinner:before,
.spinner:after {
    border-radius: 50%;
}
.spinner {
    color: #ffffff;
    font-size: 22px;
    text-indent: -99999px;
    margin: 0px auto;
    position: relative;
    width: 20px;
    height: 20px;
    box-shadow: inset 0 0 0 2px;
    transform: translateZ(0);
}
.spinner:before,
.spinner:after {
    position: absolute;
    content: "";
}
.spinner:before {
    width: 10.4px;
    height: 20.4px;
    background: #5469d4;
    border-radius: 20.4px 0 0 20.4px;
    top: -0.2px;
    left: -0.2px;
    transform-origin: 10.4px 10.2px;
    animation: loading 2s infinite ease 1.5s;
}
.spinner:after {
    width: 10.4px;
    height: 10.2px;
    background: #5469d4;
    border-radius: 0 10.2px 10.2px 0;
    top: -0.1px;
    left: 10.2px;
    transform-origin: 0px 10.2px;
    animation: loading 2s infinite ease;
}

/*WC 05132022 */
.payment-sec {
    display: flex;
    margin-top: 5px;
    justify-content: center;
    align-items: center;
}

.selected-plan-sec {
    display: flex;
    margin-top: 5px;
    justify-content: center;
    align-items: center;
}

.selected-plan {
    /*display: flex;*/
    margin-top: 100px;
    width: 30vw;
    min-width: 500px;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),
    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
    border-radius: 5px;
    padding: 40px;
    font-size: 15px;
    font-weight: 500;
    /*background-color: #6e5eff;*/
    background-color: #f7fbff;
    color: rgb(0 0 0 / 70%);
}

.selected-plan-sec .selected-plan p {
    text-align: center;
    font-weight: 500;
}

/*WC 05132022 */

/* WC 07202022 */
.modal-body p{
    display: inline-block;
    font-size: 14px;
    font-weight: normal;
    margin-left: 10px;

}

.modal-body ul{
    display: inline-block;
    font-size: 14px;
    font-weight: normal;
    margin-left: 10px;
    list-style-position: inside;
}

/* WC 07202022*/
@keyframes loading {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}


/********************************************/

.shopping-cart{
    padding-bottom: 50px;
    font-family: Roboto, "Helvetica Neue", sans-serif;
}

.shopping-cart.dark{
    background-color: #f6f6f6;
}

.shopping-cart .content{
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.075);
    background-color: white;
}

.shopping-cart .block-heading {
    padding-top: 50px;
    /*padding-top: 100px;*/
    margin-bottom: 20px;
    text-align: center;

}

.shopping-cart .block-heading p{
    text-align: center;
    max-width: 420px;
    margin: auto;
    opacity:0.7;
}

.shopping-cart .dark .block-heading p {
    opacity: 0.8;
}

.shopping-cart .block-heading h6 {
    color: #622FAD;
}

.shopping-cart .block-heading h1,
.shopping-cart .block-heading h2,
.shopping-cart .block-heading h3{
    margin-bottom:1.2rem;
    /*color: #3b99e0;*/
    color: #622FAD;
}

.shopping-cart .items{
    margin: auto;
}

.shopping-cart .items .product{
    margin-bottom: 20px;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left:0;
}

.shopping-cart .items .product .info{
    padding-top: 0px;
    text-align: center;
}

.shopping-cart .items .product .info .product-name{
    font-size: 14px;
    font-weight: 600;
    color: #622FAD;
    padding-bottom: 10px;
}

h6{
    padding-left: 12px
}

.shopping-cart .items .product .info .product-name .product-info{
    font-size: 14px;
    margin-top: 15px;
    color: rgb(0 0 0 / 70%)
}

.shopping-cart .items .product .info .product-name .product-info .value{
    font-weight: 400;
}

.shopping-cart .items .product .info .quantity .quantity-input{
    margin: auto;
    width: 80px;
}

.shopping-cart .items .product .info .price{
    /*margin-top: 15px;*/
    font-weight: bold;
    /*font-size: 22px;*/
    font-size: 18px;
    text-align: left;
}

.shopping-cart .summary{
    /*border-top: 2px solid #5ea4f3;*/
    background-color: #f7fbff;
    height: 100%;
    padding: 30px;
}

.shopping-cart .summary h3{
    text-align: center;
    font-size: 1.3em;
    font-weight: 600;
    padding-top: 20px;
    padding-bottom: 20px;
}

.shopping-cart .summary .summary-item:not(:last-of-type){
    padding-bottom: 10px;
    padding-top: 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.shopping-cart .summary .summary-item{
    padding-bottom: 10px;
    padding-top: 10px;
}

.shopping-cart .summary .text{
    font-size: 1em;
    font-weight: 600;
}

.shopping-cart .summary .price{
    font-size: 1em;
    float: right;
}

.shopping-cart .summary button{
    margin-top: 20px;
}

@media (min-width: 768px) {
    .shopping-cart .items .product {
        padding-left: 80px;
    }

    .shopping-cart .items .product .info {
        padding-top: 25px;
        text-align: left;
    }

    .shopping-cart .items .product .info .price {
        font-weight: bold;
        /*font-size: 22px;*/
        font-size: 18px;
        top: 17px;
    }

    .shopping-cart .items .product .info .quantity {
        text-align: center;
    }
    .shopping-cart .items .product .info .quantity .quantity-input {
        padding: 4px 10px;
        text-align: center;
    }
}

/*************************************/

.payment_success_divider {
    position: relative;
    border-top: 1px solid rgb(0 0 0 / 10%);
}

.payment_success_body {
    /*font-size: 16px;*/
    font-size: 18px;
    line-height: 26px;
    /*text-transform: uppercase;*/
    margin-top: 0;
    color: rgb(0 0 0 / 90%);
    /*color: #929090*/
}

.paid-detail {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    line-height: 30px;
    font-weight: 400;
    color: rgb(0 0 0);
}

.cust-detail {
    font-size: 1em;
    font-weight: 800;
    margin-right: 10px;
}

@media (max-width: 425px) {
    .cust-detail{
        width: 100%;
    }
}

/*.payment_success_body .paid-detail .paid-value {
   color: rgb(0 0 0 / 70%);
 } */

.link {
    color: #6C2FBB;
    font-weight: 500;
}


/*shopping cart header- owl carousel*/


.group-list {
    margin-top: 2rem;
    background: #FFFFFF;
    padding: 15px 20px;
    border: 1px solid #F8F8F8;
    border-radius: 16px;
}

.group-list-img {
    object-fit: contain;
    width: 70px !important;
    height: 70px;
    margin: 0 auto;

    /*box-shadow: 0px 0px 2px 0px rgb(0 0 0 / 50%) !important*/
}

.owl-carousel-two .img-box:hover {
    border-radius: 9px;
}

.owl-carousel-two .img-box-create {
    box-shadow: 0px 0px 2px 0px rgb(0 0 0 / 50%) !important;
    margin: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 68px;
    height: 68px;
    color: #6c2fbb;
}

.owl-carousel-two .img-box {
    overflow: hidden;
    border-radius: 50px;
    transition: 0.5s;
    cursor: pointer;
    /*position: relative;*/
    margin: 1px 1px 16px;
}

.owl-carousel-two .img-box.active:after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    bottom: 0;
    right: auto;
    left: auto;
    background-image: radial-gradient(circle at center, #6c2fbb 4px, transparent 5px);
    background-size: 15px 15px;
    background-position: bottom center;
    background-repeat: no-repeat;
}

.owl-carousel-two .img-box.premium {
    box-shadow: 0 0 2px 1px #6c2fbb !important;
}

.owl-carousel-two {
    max-width: 95%;
    margin: 0 auto;
}

@media (max-width: 1024px) {
    .owl-carousel-two {
        max-width: 86%;
    }
}

@media (max-width: 520px) {
    .selected-plan {
        padding: 20px;
        min-width: 400px;
        margin-top: 40px;
    }
    #payment-form {
        padding: 20px;
        min-width: 400px;
    }
}
@media (max-width: 512px) {
    .group-list-img, .img-box-create {
        width: 60px !important;
        height: 60px !important;
    }
}
@media (max-width: 420px) {
    .selected-plan {
        min-width: 310px; 
    }
    #payment-form {
        min-width: 310px;
    }
}

/*img.user-profile-pic {*/
/*    width: 50px;*/
/*    height: 50px;*/
/*    object-fit: cover;*/
/*    border-radius: 13px;*/
/*}*/

.left-image img, .left-image span {
    width: 40px !important;
    height: 40px !important;
    border-radius: 13px;
}

.left-image .profile-image {
    width: 40px !important;
    height: 40px !important;
    font-size: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/community-checkout/community-checkout.component.css"],"names":[],"mappings":"AAAA,cAAc;AACd;IACI,sBAAsB;AAC1B;;AAEA;;;;;;;;;GASG;;AAEH;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB;gFAC4E;IAC5E,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,sBAAsB;;AAEtB;;;;;;;;;;;;;;;;;;;;;EAqBE;;AAEF,qCAAqC;AACrC;;;IAGI,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,2BAA2B;IAG3B,wBAAwB;AAC5B;AACA;;IAEI,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,gCAAgC;IAChC,WAAW;IACX,YAAY;IAEZ,+BAA+B;IAE/B,wCAAwC;AAC5C;AACA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,gCAAgC;IAChC,WAAW;IACX,YAAY;IAEZ,4BAA4B;IAE5B,mCAAmC;AACvC;;AAEA,eAAe;AACf;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB;gFAC4E;IAC5E,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,eAAe;;AAEf,gBAAgB;AAChB;IACI,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;;AAErB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA,eAAe;AAYf;IACI;QAEI,uBAAuB;IAC3B;IACA;QAEI,yBAAyB;IAC7B;AACJ;;;AAGA,6CAA6C;;AAE7C;IACI,oBAAoB;IACpB,iDAAiD;AACrD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6CAA6C;IAC7C,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;;AAEtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;IAGI,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,yBAAyB;IACzB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;IACjB,2CAA2C;AAC/C;;AAEA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,eAAe;QACf,SAAS;IACb;;IAEA;QACI,kBAAkB;IACtB;IACA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA,sCAAsC;;AAEtC;IACI,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,aAAa;IACb,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;;IAEI;;AAEJ;IACI,cAAc;IACd,gBAAgB;AACpB;;;AAGA,qCAAqC;;;AAGrC;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,cAAc;;IAEd,0DAA0D;AAC9D;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uDAAuD;IACvD,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,UAAU;IACV,iFAAiF;IACjF,0BAA0B;IAC1B,kCAAkC;IAClC,4BAA4B;AAChC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,gBAAgB;QAChB,gBAAgB;IACpB;IACA;QACI,aAAa;QACb,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ;AACA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;AACJ;;AAEA,yBAAyB;AACzB,mBAAmB;AACnB,oBAAoB;AACpB,yBAAyB;AACzB,2BAA2B;AAC3B,IAAI;;AAEJ;IACI,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;AACnB","sourcesContent":["/* Variables */\n* {\n    box-sizing: border-box;\n}\n\n/* body {\n  font-family: -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: 16px;\n  -webkit-font-smoothing: antialiased;\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  height: 100vh;\n  width: 100vw;\n} */\n\nform {\n    width: 30vw;\n    min-width: 500px;\n    align-self: center;\n    box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),\n    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);\n    border-radius: 5px;\n    padding: 40px;\n}\n\n.cursor {\n    cursor: pointer;\n}\n\n.promoCodeInput {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    width: 50%;\n}\n\n.hidden {\n    display: none;\n}\n\n#payment-message {\n    color: rgb(149, 40, 0);\n    font-size: 16px;\n    line-height: 20px;\n    padding-top: 12px;\n    text-align: center;\n}\n\n#payment-element {\n    margin-bottom: 24px;\n}\n\n/* Buttons and links */\n\n/*button {\n  background: #6e5eff;\n  font-family: Roboto, \"Helvetica Neue\", sans-serif;\n  color: #ffffff;\n  border-radius: 5px;\n  border: 0;\n  padding: 12px 16px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  display: block;\n  transition: all 0.2s ease;\n  box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);\n  width: 100%;\n}\nbutton:hover {\n  filter: contrast(115%);\n}\nbutton:disabled {\n  opacity: 0.5;\n  cursor: default;\n}*/\n\n/* spinner/processing state, errors */\n.spinner,\n.spinner:before,\n.spinner:after {\n    border-radius: 50%;\n}\n.spinner {\n    color: #ffffff;\n    font-size: 22px;\n    text-indent: -99999px;\n    margin: 0px auto;\n    position: relative;\n    width: 20px;\n    height: 20px;\n    box-shadow: inset 0 0 0 2px;\n    -webkit-transform: translateZ(0);\n    -ms-transform: translateZ(0);\n    transform: translateZ(0);\n}\n.spinner:before,\n.spinner:after {\n    position: absolute;\n    content: \"\";\n}\n.spinner:before {\n    width: 10.4px;\n    height: 20.4px;\n    background: #5469d4;\n    border-radius: 20.4px 0 0 20.4px;\n    top: -0.2px;\n    left: -0.2px;\n    -webkit-transform-origin: 10.4px 10.2px;\n    transform-origin: 10.4px 10.2px;\n    -webkit-animation: loading 2s infinite ease 1.5s;\n    animation: loading 2s infinite ease 1.5s;\n}\n.spinner:after {\n    width: 10.4px;\n    height: 10.2px;\n    background: #5469d4;\n    border-radius: 0 10.2px 10.2px 0;\n    top: -0.1px;\n    left: 10.2px;\n    -webkit-transform-origin: 0px 10.2px;\n    transform-origin: 0px 10.2px;\n    -webkit-animation: loading 2s infinite ease;\n    animation: loading 2s infinite ease;\n}\n\n/*WC 05132022 */\n.payment-sec {\n    display: flex;\n    margin-top: 5px;\n    justify-content: center;\n    align-items: center;\n}\n\n.selected-plan-sec {\n    display: flex;\n    margin-top: 5px;\n    justify-content: center;\n    align-items: center;\n}\n\n.selected-plan {\n    /*display: flex;*/\n    margin-top: 100px;\n    width: 30vw;\n    min-width: 500px;\n    justify-content: center;\n    align-items: center;\n    box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),\n    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);\n    border-radius: 5px;\n    padding: 40px;\n    font-size: 15px;\n    font-weight: 500;\n    /*background-color: #6e5eff;*/\n    background-color: #f7fbff;\n    color: rgb(0 0 0 / 70%);\n}\n\n.selected-plan-sec .selected-plan p {\n    text-align: center;\n    font-weight: 500;\n}\n\n/*WC 05132022 */\n\n/* WC 07202022 */\n.modal-body p{\n    display: inline-block;\n    font-size: 14px;\n    font-weight: normal;\n    margin-left: 10px;\n\n}\n\n.modal-body ul{\n    display: inline-block;\n    font-size: 14px;\n    font-weight: normal;\n    margin-left: 10px;\n    list-style-position: inside;\n}\n\n/* WC 07202022*/\n\n@-webkit-keyframes loading {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n    100% {\n        -webkit-transform: rotate(360deg);\n        transform: rotate(360deg);\n    }\n}\n@keyframes loading {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg);\n    }\n    100% {\n        -webkit-transform: rotate(360deg);\n        transform: rotate(360deg);\n    }\n}\n\n\n/********************************************/\n\n.shopping-cart{\n    padding-bottom: 50px;\n    font-family: Roboto, \"Helvetica Neue\", sans-serif;\n}\n\n.shopping-cart.dark{\n    background-color: #f6f6f6;\n}\n\n.shopping-cart .content{\n    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.075);\n    background-color: white;\n}\n\n.shopping-cart .block-heading {\n    padding-top: 50px;\n    /*padding-top: 100px;*/\n    margin-bottom: 20px;\n    text-align: center;\n\n}\n\n.shopping-cart .block-heading p{\n    text-align: center;\n    max-width: 420px;\n    margin: auto;\n    opacity:0.7;\n}\n\n.shopping-cart .dark .block-heading p {\n    opacity: 0.8;\n}\n\n.shopping-cart .block-heading h6 {\n    color: #622FAD;\n}\n\n.shopping-cart .block-heading h1,\n.shopping-cart .block-heading h2,\n.shopping-cart .block-heading h3{\n    margin-bottom:1.2rem;\n    /*color: #3b99e0;*/\n    color: #622FAD;\n}\n\n.shopping-cart .items{\n    margin: auto;\n}\n\n.shopping-cart .items .product{\n    margin-bottom: 20px;\n    padding-top: 20px;\n    padding-bottom: 20px;\n    padding-left:0;\n}\n\n.shopping-cart .items .product .info{\n    padding-top: 0px;\n    text-align: center;\n}\n\n.shopping-cart .items .product .info .product-name{\n    font-size: 14px;\n    font-weight: 600;\n    color: #622FAD;\n    padding-bottom: 10px;\n}\n\nh6{\n    padding-left: 12px\n}\n\n.shopping-cart .items .product .info .product-name .product-info{\n    font-size: 14px;\n    margin-top: 15px;\n    color: rgb(0 0 0 / 70%)\n}\n\n.shopping-cart .items .product .info .product-name .product-info .value{\n    font-weight: 400;\n}\n\n.shopping-cart .items .product .info .quantity .quantity-input{\n    margin: auto;\n    width: 80px;\n}\n\n.shopping-cart .items .product .info .price{\n    /*margin-top: 15px;*/\n    font-weight: bold;\n    /*font-size: 22px;*/\n    font-size: 18px;\n    text-align: left;\n}\n\n.shopping-cart .summary{\n    /*border-top: 2px solid #5ea4f3;*/\n    background-color: #f7fbff;\n    height: 100%;\n    padding: 30px;\n}\n\n.shopping-cart .summary h3{\n    text-align: center;\n    font-size: 1.3em;\n    font-weight: 600;\n    padding-top: 20px;\n    padding-bottom: 20px;\n}\n\n.shopping-cart .summary .summary-item:not(:last-of-type){\n    padding-bottom: 10px;\n    padding-top: 10px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.shopping-cart .summary .summary-item{\n    padding-bottom: 10px;\n    padding-top: 10px;\n}\n\n.shopping-cart .summary .text{\n    font-size: 1em;\n    font-weight: 600;\n}\n\n.shopping-cart .summary .price{\n    font-size: 1em;\n    float: right;\n}\n\n.shopping-cart .summary button{\n    margin-top: 20px;\n}\n\n@media (min-width: 768px) {\n    .shopping-cart .items .product {\n        padding-left: 80px;\n    }\n\n    .shopping-cart .items .product .info {\n        padding-top: 25px;\n        text-align: left;\n    }\n\n    .shopping-cart .items .product .info .price {\n        font-weight: bold;\n        /*font-size: 22px;*/\n        font-size: 18px;\n        top: 17px;\n    }\n\n    .shopping-cart .items .product .info .quantity {\n        text-align: center;\n    }\n    .shopping-cart .items .product .info .quantity .quantity-input {\n        padding: 4px 10px;\n        text-align: center;\n    }\n}\n\n/*************************************/\n\n.payment_success_divider {\n    position: relative;\n    border-top: 1px solid rgb(0 0 0 / 10%);\n}\n\n.payment_success_body {\n    /*font-size: 16px;*/\n    font-size: 18px;\n    line-height: 26px;\n    /*text-transform: uppercase;*/\n    margin-top: 0;\n    color: rgb(0 0 0 / 90%);\n    /*color: #929090*/\n}\n\n.paid-detail {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 14px;\n    line-height: 30px;\n    font-weight: 400;\n    color: rgb(0 0 0);\n}\n\n.cust-detail {\n    font-size: 1em;\n    font-weight: 800;\n    margin-right: 10px;\n}\n\n@media (max-width: 425px) {\n    .cust-detail{\n        width: 100%;\n    }\n}\n\n/*.payment_success_body .paid-detail .paid-value {\n   color: rgb(0 0 0 / 70%);\n } */\n\n.link {\n    color: #6C2FBB;\n    font-weight: 500;\n}\n\n\n/*shopping cart header- owl carousel*/\n\n\n.group-list {\n    margin-top: 2rem;\n    background: #FFFFFF;\n    padding: 15px 20px;\n    border: 1px solid #F8F8F8;\n    border-radius: 16px;\n}\n\n.group-list-img {\n    object-fit: contain;\n    width: 70px !important;\n    height: 70px;\n    margin: 0 auto;\n\n    /*box-shadow: 0px 0px 2px 0px rgb(0 0 0 / 50%) !important*/\n}\n\n.owl-carousel-two .img-box:hover {\n    border-radius: 9px;\n}\n\n.owl-carousel-two .img-box-create {\n    box-shadow: 0px 0px 2px 0px rgb(0 0 0 / 50%) !important;\n    margin: 2px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    width: 68px;\n    height: 68px;\n    color: #6c2fbb;\n}\n\n.owl-carousel-two .img-box {\n    overflow: hidden;\n    border-radius: 50px;\n    transition: 0.5s;\n    cursor: pointer;\n    /*position: relative;*/\n    margin: 1px 1px 16px;\n}\n\n.owl-carousel-two .img-box.active:after {\n    content: \"\";\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    bottom: 0;\n    right: auto;\n    left: auto;\n    background-image: radial-gradient(circle at center, #6c2fbb 4px, transparent 5px);\n    background-size: 15px 15px;\n    background-position: bottom center;\n    background-repeat: no-repeat;\n}\n\n.owl-carousel-two .img-box.premium {\n    box-shadow: 0 0 2px 1px #6c2fbb !important;\n}\n\n.owl-carousel-two {\n    max-width: 95%;\n    margin: 0 auto;\n}\n\n@media (max-width: 1024px) {\n    .owl-carousel-two {\n        max-width: 86%;\n    }\n}\n\n@media (max-width: 520px) {\n    .selected-plan {\n        padding: 20px;\n        min-width: 400px;\n        margin-top: 40px;\n    }\n    #payment-form {\n        padding: 20px;\n        min-width: 400px;\n    }\n}\n@media (max-width: 512px) {\n    .group-list-img, .img-box-create {\n        width: 60px !important;\n        height: 60px !important;\n    }\n}\n@media (max-width: 420px) {\n    .selected-plan {\n        min-width: 310px; \n    }\n    #payment-form {\n        min-width: 310px;\n    }\n}\n\n/*img.user-profile-pic {*/\n/*    width: 50px;*/\n/*    height: 50px;*/\n/*    object-fit: cover;*/\n/*    border-radius: 13px;*/\n/*}*/\n\n.left-image img, .left-image span {\n    width: 40px !important;\n    height: 40px !important;\n    border-radius: 13px;\n}\n\n.left-image .profile-image {\n    width: 40px !important;\n    height: 40px !important;\n    font-size: 15px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
